module.exports = __webpack_public_path__ + "assets/img/1.a524f0d6.jpg";